import {getUser} from './auth'

export const getApiUrl = () => {
  const apiId = '7q0la07oz2'
  return `https://${apiId}.execute-api.us-east-1.amazonaws.com/Prod`
};

export const getAIChatUrl = () => {
  return `https://wvrilbjkeilav2pcsbifq7hve40xdjzf.lambda-url.us-east-1.on.aws`
};

export const adminGetSettings = async (user, onSuccess, onError, retries=3) => {
  try {
    let q = '/admin/settings'
    const response = await fetch(getApiUrl()+q, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.settings);
    } else {

      onError(response);
    }
  } catch (error) {
    console.log("error",error);
    onError(error);
  } finally {
  }
}

export const adminUpdateSettings = async (user, data, onSuccess, onError, retries=3) => {
  try {
    let q = '/admin/settings'
    const response = await fetch(getApiUrl()+q, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.settings);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const adminGetUsers = async (user, onSuccess, onError, retries=3) => {
  try {
    let q = '/admin/users'
    const response = await fetch(getApiUrl()+q, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.users);
    } else {

      onError(response);
    }
  } catch (error) {
    console.log("error",error);
    onError(error);
  } finally {
  }
}

export const adminGetCompanies = async (user, onSuccess, onError, retries=3) => {
  try {
    let q = '/admin/companies'
    const response = await fetch(getApiUrl()+q, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.companies);
    } else {

      onError(response);
    }
  } catch (error) {
    console.log("error",error);
    onError(error);
  } finally {
  }
}

export const adminUpdateUser = async (user, data, onSuccess, onError, retries=3) => {
  try {
    let q = '/admin/users'
    const response = await fetch(getApiUrl()+q, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.resource);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const adminReaddUser = async (user, data, onSuccess, onError, retries=3) => {
  try {
    let q = '/admin/users/readd'
    const response = await fetch(getApiUrl()+q, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.users);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const adminReaddAllUsers = async (user, data, onSuccess, onError, retries=3) => {
  try {
    let q = '/admin/users/readdall'
    const response = await fetch(getApiUrl()+q, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.users);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const adminDeleteUser = async (user, data, onSuccess, onError, retries=3) => {
  try {
    let q = '/admin/users'
    const response = await fetch(getApiUrl()+q, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const adminUpdateCompany = async (user, data, onSuccess, onError, retries=3) => {
  try {
    let q = '/admin/companies'
    const response = await fetch(getApiUrl()+q, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.resource);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const getUserDetails = async (user, onSuccess, onError, retries=3) => {
  try {
    let q = '/user'
    const response = await fetch(getApiUrl()+q, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.company);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const updateUserDetails = async (user, data, onSuccess, onError, retries=3) => {
  try {
    let q = '/user'
    const response = await fetch(getApiUrl()+q, {
      method: 'PUT',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      r.user_details.sub = user.signInUserSession.idToken.payload.sub;
      r.user_details.email = user.signInUserSession.idToken.payload.email;
      r.user_details.phone = user.signInUserSession.idToken.payload.phone_number;
      r.user_details.image = user.signInUserSession.idToken.payload.picture;
      onSuccess(r.user_details);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const getProfile = async (id, onSuccess, onError, retries=3) => {
  try {
    let q = '/public/profile/'+id
    const response = await fetch(getApiUrl()+q, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.profile);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const getAPIReportData = async (path, user, data, onSuccess, onError, partial_data=[], retries=3) => {
  try {
    const response = await fetch(getApiUrl()+path, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      if (r.lastkey) {
        data['lastkey']=r.lastkey
        getAPIReportData(path, user, data, onSuccess, onError, r.data);
      } else {
        onSuccess([...partial_data, ...r.data]);
      }
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const getAPIAIHelp = async (path, user, data, onSuccess, onError, retries=3) => {
  try {
    if (!user || !user.signInUserSession) {
      onError("User not signed in.");
      return;
    }
    const response = await fetch(getApiUrl()+path, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.result);

    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const searchAIKB = async (user, data, onSuccess, onError) => {
  try {
    if (!user || !user.signInUserSession) {
      onError("User not signed in.");
      return;
    }
    const response = await fetch(getApiUrl() + '/search', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.references);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  }
};

export const postAIChatData = async (user, data, onData, onDone, onError) => {
  console.log(data);
  
  try {
    const response = await fetch(getAIChatUrl() + '/chat', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      onError(response);
      return;
    }

    const reader = response.body.getReader();
    const decoder = new TextDecoder();

    while (true) {
      const { value, done } = await reader.read();
      if (done) {
        onDone();
        break;
      }

      const chunk = decoder.decode(value);
      const lines = chunk.split('\n').filter(line => line.trim() !== '');
      for (const line of lines) {
        if (line.startsWith('data: ')) {
          const json = JSON.parse(line.substring(6));
          onData(json);
        }
      }
    }
  } catch (error) {
    onError(error);
  }
}

export const getAIChatHistory = async (user, onSuccess, onError) => {
  try {
    if (!user || !user.signInUserSession) {
      onError("User not signed in.");
      return;
    }
    const response = await fetch(getApiUrl() + '/conversations', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + user.signInUserSession.idToken.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  }
};

export const getAIChatConversation = async (user, sessionId, onSuccess, onError) => {
  try {
    if (!user || !user.signInUserSession) {
      onError("User not signed in.");
      return;
    }
    const response = await fetch(getApiUrl() + '/conversations/' + sessionId + '/messages', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + user.signInUserSession.idToken.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.messages);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  }
};

export const getKBIngestionStatus = async (user, onSuccess, onError) => {
  try {
    if (!user || !user.signInUserSession) {
      onError("User not signed in.");
      return;
    }
    const response = await fetch(getApiUrl() + '/kb/ingestion/status', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.jwtToken || user.signInUserSession.idToken.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  }
};


export const triggerKBIngestion = async (user, options = {}, onSuccess, onError) => {
  if (typeof options === 'function') {
    onError = onSuccess;
    onSuccess = options;
    options = {};
  }
  try {
    if (!user || !user.signInUserSession) {
      if (onError) onError("User not signed in.");
      return;
    }
    const fetchOptions = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken?.jwtToken || user.signInUserSession.jwtToken,
      }
    };
    if (options && Object.keys(options).length > 0) {
      fetchOptions.body = JSON.stringify(options);
    }
    const response = await fetch(getApiUrl() + '/kb/ingestion', fetchOptions);
    const r = await response.json();
    if (response.ok) {
      if (onSuccess) onSuccess(r);
    } else {
      if (onError) onError(r?.error ? r : response);
    }
  } catch (error) {
    if (onError) onError(error);
  }
};

export const triggerSharePointSync = async (user, options = {}, onSuccess, onError) => {
  try {
    if (!user || !user.signInUserSession) {
      onError("User not signed in.");
      return;
    }
    const response = await fetch(getApiUrl() + '/kb/sharepoint/sync', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken?.jwtToken || user.signInUserSession.jwtToken,
      },
      body: JSON.stringify(options)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  }
};

export const getSharePointSyncStatus = async (user, onSuccess, onError) => {
  try {
    if (!user || !user.signInUserSession) {
      onError("User not signed in.");
      return;
    }
    const response = await fetch(getApiUrl() + '/kb/sharepoint/sync/status', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken?.jwtToken || user.signInUserSession.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  }
};

export const getKBStatus = async (user, onSuccess, onError) => {
  try {
    if (!user || !user.signInUserSession) {
      onError("User not signed in.");
      return;
    }
    const response = await fetch(getApiUrl() + '/kb/status', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.jwtToken || user.signInUserSession.idToken?.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  }
};

export const getSharePointConfig = async (user, onSuccess, onError) => {
  try {
    if (!user || !user.signInUserSession) {
      onError("User not signed in.");
      return;
    }
    const response = await fetch(getApiUrl() + '/kb/sharepoint/config', {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken?.jwtToken || user.signInUserSession.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  }
};

export const updateSharePointConfig = async (user, config, onSuccess, onError) => {
  try {
    if (!user || !user.signInUserSession) {
      onError("User not signed in.");
      return;
    }
    const response = await fetch(getApiUrl() + '/kb/sharepoint/config', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken?.jwtToken || user.signInUserSession.jwtToken,
      },
      body: JSON.stringify(config)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  }
};

export const getAPIData = async (path, user, onSuccess, onError, retries=3) => {
  try {
    const response = await fetch(getApiUrl()+path, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.data);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const deleteAPIData = async (path, user, onSuccess, onError, retries=3) => {
  try {
    const response = await fetch(getApiUrl()+path, {
      method: 'DELETE',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      }
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.data);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}

export const updateAPIReportData = async (path, user, data, onSuccess, onError, retries=3) => {
  try {
    const response = await fetch(getApiUrl()+path, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': user.signInUserSession.idToken.jwtToken,
      },
      body: JSON.stringify(data)
    });
    const r = await response.json();
    if (response.ok) {
      onSuccess(r.data);
    } else {
      onError(response);
    }
  } catch (error) {
    onError(error);
  } finally {
  }
}





const dateToLocalTZ = (data) => {
  const dateOffset = (new Date()).getTimezoneOffset();
  var dsd = new Date(data);
  dsd.setTime(dsd.getTime() + dateOffset * 60000);
  return dsd;
}

export const sifTimesOfEvent = [{value:"(Overnight) 12am-6am"}, {value:"(Morning) 6am-12pm"}, {value:"(Afternoon) 12pm-6pm"}, {value:"(Evening) 6pm-12am"}, {value:"Unknown"},]

export const iogpValues = [{value:"No Violation"},{value:"Bypassing Safety Controls"},
  {value:"Confined Space"},{value:"Driving"},{value:"Energy Isolation"},
  {value:"Hot Work"},{value:"Line of Fire"},{value:"Safe Mechanical Lifting"},
  {value:"Work Authorization"},{value:"Working at Height"}];

export const yesnoValues = [{value:"Yes"},{value:"No"},{value:"Undetermined"}]

export const causalValues = [{value:"People"},{value:"Engineering"},{value:"Procedural"}]

export const sifStatusValues = [{value:"Pending"},{value:"Closed"},{value:"NA"}]

export const weekDays = [
  {
    ID: 1,
    Name: 'Mon',
    Value: 'Monday'
  },
  {
    ID: 2,
    Name: 'Tue',
    Value: 'Tuesday'
  },
  {
    ID: 3,
    Name: 'Wed',
    Value: 'Wednesday'
  },
  {
    ID: 4,
    Name: 'Thu',
    Value: 'Thursday'
  },
  {
    ID: 5,
    Name: 'Fri',
    Value: 'Friday'
  },
  {
    ID: 6,
    Name: 'Sat',
    Value: 'Saturday'
  },
  {
    ID: 7,
    Name: 'Sun',
    Value: 'Sunday'
  }
]
